import { useState } from 'react'

import type { ImportReport } from '../utils/importReport'
import { readImportReport } from '../utils/importReport'

/**
 * SN-4838 — an import modal's report of its last 409, and whether its duplicate
 * review is open. A report of duplicates alone opens the review at once; one
 * that also lists problem rows waits for "Review Duplicates".
 */
export const useImportReport = () => {
  'use memo'
  const [report, setReport] = useState<ImportReport | null>(null)
  const [isReviewing, setIsReviewing] = useState(false)

  /** `droppedLines`: the lines the review left out of the file it posted. */
  const receive = (body: unknown, droppedLines: readonly number[] = []) => {
    const next = readImportReport(body, droppedLines)
    setReport(next)
    setIsReviewing(next.kind === 'duplicates')
  }

  const startReview = () => setIsReviewing(true)

  /** A new file, Cancel Import and a successful confirm start over. */
  const clear = () => {
    setReport(null)
    setIsReviewing(false)
  }

  return { report, isReviewing, receive, startReview, clear }
}
